import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { WallsVortexTutorialState } from './WallsTutorialAdapter.js';

type VState = WallsVortexTutorialState;

const PARTIAL = 'A0A1E,C0D0S';
const PARTIAL_GATED = `${PARTIAL}|A4=D3`;
const SOLVED = 'A2B2S,C1C2E,A0A1E,C0D0N|A4=D3';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { walls: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'C2', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'D5', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { walls: PARTIAL },
                { walls: PARTIAL, gateMode: true },
                { walls: PARTIAL_GATED, gateMode: true },
                { walls: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle an unblocked pair active; a blocked pair stays amber
    {
        gameState: { walls: 'B5C5E', gateMode: true, extraGates: [['B5', 'D5']] } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'B3', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'Walls block\ngate activation', cell: 'B5', anchor: 'far-above', color: COLORS.amber },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { walls: 'B5C5E', gateMode: true, extraGates: [['B5', 'D5']] },
                { walls: 'B5C5E|A4=D3', gateMode: true, extraGates: [['B5', 'D5']] },
            ] as VState[],
        },
    },

    // Scene 3: Block teleportation
    {
        gameState: { walls: PARTIAL_GATED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Block enters\na gate...', cell: 'C2', anchor: 'center' },
            { type: 'text-label', text: '...exits from\nthe other side', cell: 'B5', anchor: 'center' },
            { type: 'pulse', cell: 'A4', color: COLORS.purple },
            { type: 'pulse', cell: 'D3', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state
    {
        gameState: { walls: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Gates can be\nused multiple times', cell: 'C0', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'A4', color: COLORS.purple },
            { type: 'pulse', cell: 'D3', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Walls tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches block teleportation through Vortex gates.
 */
export const WALLS_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'walls-vortex',
    gridCode: '6/0-3:0C4,1F2,2A3,3D1',
    scenes,
    previewScene: 3,
};
